export default {
  title: 'Period',
  change: 'Change display period',
  today: 'Today'
}